import {Component} from 'react'

import Header from '../Header'
import CartListView from '../CartListView'
import CartContext from '../../context/CartContext'
import EmptyCartView from '../EmptyCartView'
import CartSummary from '../CartSummary'
import { FiTrash2 } from 'react-icons/fi'

import './index.css'

class Cart extends Component {
  componentDidMount() {
    const {loadCart} = this.context
    loadCart()
  }

  render() {
    const {cartList, removeAllCartItems} = this.context

    const onClickRemoveAllCartItems = () => {
      removeAllCartItems()
    }

    const showEmptyView = cartList.length === 0

    let totalPrice = 0
    let totalItems = 0

    if (!showEmptyView) {
      totalPrice = cartList.reduce(
        (acc, eachItem) => acc + eachItem.price * eachItem.quantity,
        0,
      )

      totalItems = cartList.reduce(
        (acc, eachItem) => acc + eachItem.quantity,
        0,
      )
    }

    return (
      <>
        <Header />
        <div className="cart-container">
          {showEmptyView ? (
            <EmptyCartView />
          ) : (
            <div className="cart-content-container">
              <div className="cart-page-header">
                <h1 className="cart-heading">
                  My Shopping Cart <span className="cart-badge-count">{cartList.length}</span>
                </h1>
                <button
                  type="button"
                  className="remove-all-carts"
                  onClick={onClickRemoveAllCartItems}
                >
                  <FiTrash2 className="remove-all-icon" /> Remove All Items
                </button>
              </div>
              
              <div className="cart-split-view">
                <div className="cart-left-column">
                  <CartListView />
                </div>
                <div className="cart-right-column">
                  <CartSummary totalItems={totalItems} totalPrice={totalPrice} />
                </div>
              </div>
            </div>
          )}
        </div>
      </>
    )
  }
}

Cart.contextType = CartContext

export default Cart
